import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Enconstruccion from "../Blog/Enconstruccion"
import Home from "../Blog/Home.blog"
import LayoutBlog from "../Blog/Layout.blog"
import ArticuloAhorro from "../Blog/Articulo1.blog"
import InicioLibro from "../Blog/Libro/Inicio"
import Page404 from "../Blog/Page404"


const Rutas = () => {


    return (
        <Router>
            <Routes>
                {/* Layout del blog */}
                <Route element={<LayoutBlog />}>

                    <Route path="/" element={<Home />} />
                    <Route path="/libro" element={<InicioLibro />} />

                    <Route path="/ahorro" element={<ArticuloAhorro />} />

                    
                </Route>
                <Route path="*" element={<Page404 />} />


            </Routes>
        </Router>
    )



}

export default Rutas